module.exports = __webpack_public_path__ + "static/Fishing-c63cba930563b9ba0d1a6ca17b01ed07.jpg";